import { EllipsisOutlined } from "@ant-design/icons";
import { Avatar, Popover } from "antd";
import Text from "antd/lib/typography/Text";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { VideoApi } from "../../api/backend/video";
import { TagVideoList } from "../../component/video/TagVideoList";
import { setIdPlay } from "../../redux/video";
import {
  convertGoogleDriveLinkToEmbed,
  getThumbnailFromEmbedUrl,
} from "../../utils/helper";
import NewIcon from "./newIcon";
import VideoAction from "./videoAction";
import "./view.scss";

const VideoFrame = ({
  videoId,
  title,
  description,
  author,
  tag = [],
  time,
  url,
  updateDeleteList,
  machineList = [],
  isDelete,
  isEdit,
  createTime,
  isVideoPlayList,
  callBackAddPlayList,
  avatarUrl
}) => {
  const history = useHistory();
  const videoUrl = convertGoogleDriveLinkToEmbed(url);
  const dispatch = useDispatch();
  const [isNew, setIsNew] = useState(false);

  const containerRef = useRef(null);
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsInView(entry.isIntersecting);
      },
      {
        threshold: 0.1,
      }
    );
    if (containerRef.current) {
      observer.observe(containerRef.current);
    }
    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  const handleToView = async () => {
    history.push("/VideoManagement/View/" + videoId);
    await VideoApi.addCountView(videoId);
  };

  useEffect(() => {
    const checkNew = () => {
      const created = new Date(createTime).getTime();
      const now = Date.now();
      setIsNew(now - created < 20 * 1000);
    };

    checkNew();
    const interval = setInterval(checkNew, 1000);
    return () => clearInterval(interval);
  }, [createTime]);

  return (
    <div className="video-card" ref={containerRef}>
      <div className="video-frame">
        {isNew && <NewIcon />}
        {isInView ? (
          <iframe
            className="video-iframe"
            src={videoUrl}
            title={title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        ) : (
          <div
            onClick={() => dispatch(setIdPlay(videoId))}
            style={{
              width: "100%",
              height: 250,
              background: "",
              borderRadius: "0 0 10px 10px",
              marginBottom: 10,
              cursor: "pointer",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/* <PlayCircleOutlined
              style={{
                fontSize: 70,
                color: "#cccccc",
              }}
            /> */}
          </div>
        )}

        <div onClick={handleToView} className="video-meta">
          <div className="video-wrap-title">
            <div className="video-title video-text-two-line ">{title}</div>
            <div
              style={{
                width: 50,
                cursor: "pointer",
                textAlign: "end",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <Popover
                overlayClassName="video-popover"
                content={
                  <VideoAction
                    callBackAddPlayList={callBackAddPlayList}
                    isVideoPlayList={isVideoPlayList}
                    isDelete={isDelete}
                    isEdit={isEdit}
                    callbackDelete={updateDeleteList}
                    videoId={videoId}
                  />
                }
                trigger="click"
                placement="bottomLeft"
              >
                <EllipsisOutlined
                  style={{
                    transform: "rotate(90deg)",
                    fontSize: 20,
                    fontWeight: "800",
                  }}
                />{" "}
              </Popover>
            </div>
          </div>
          <div className="video-wrap-author">
            <div className="video-author-name">
              <Avatar src={avatarUrl} size={"default"} className="video-comment-avatar">
                {String(author).charAt(0).toUpperCase()}
              </Avatar>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  className="video-comment-header"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <Text className="video-comment-author" strong>
                    {author}
                  </Text>
                </div>
              </div>
            </div>
            <div style={{ fontSize: 12, color: "gray" }}>{time}</div>
          </div>
          <div className="mt5 mb5">
            <TagVideoList isKeepPage={true} isNewPage={false} tags={tag} />
            {/* {tag.map((i, index) => (
              <span style={{ color: "#0080cb" }} key={index}>
                {i} {index !== tag.length - 1 ? ", " : ""}
              </span>
            ))} */}
          </div>
          {machineList.length > 0 && (
            <div style={{}} className="video-text-one-line">
              機器名 : {machineList.join(", ")}
            </div>
          )}
          <div className="video-text-one-line">{description}</div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(VideoFrame);
